import styled from "@emotion/styled";
import { SinglePlaylistSkeleton } from "@kaltura/mediaspace-shared-ui";
import React from "react";

export interface PlaylistsCarouselsSkeletonProps {
    numberOfLines: number;
    fullScreenWidth: boolean;
}

const SkeletonContainer = styled("div")(({ theme }) => ({
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(4),
}));

/**
 * Skeleton for SinglePlaylist component
 */
export function PlaylistsCarouselsSkeleton({ numberOfLines, fullScreenWidth }: PlaylistsCarouselsSkeletonProps) {
    return (
        <SkeletonContainer>
            {[...Array(numberOfLines)].map((_, index) => (
                <SinglePlaylistSkeleton key={index} fullScreenWidth={fullScreenWidth} />
            ))}
        </SkeletonContainer>
    );
}

export default PlaylistsCarouselsSkeleton;
